import { Avatar } from "@ui/Avatar";
import { formatDurationClockShort } from "@ui/format";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import { MetaList } from "@ui/MetaList";
import type { VideoEvidenceInfluencer } from "../../ChatEventTypes";

export const VideoAvatarPill = (props: {
	influencer?: VideoEvidenceInfluencer;
	duration: number;
	viewCount?: number | null;
	onInfluencerClick?: (event: MouseEvent) => void;
}) => {
	const hasProfile = () =>
		Boolean(props.influencer?.handle || props.influencer?.profile_picture_url);
	const profileDetails = () => (
		<VStack>
			<Show when={props.influencer?.handle}>
				{(handle) => (
					<Text size="standard" color="white" weight="semi-bold">
						@{handle()}
					</Text>
				)}
			</Show>
			<MetaList style={{ color: "var(--white)" }}>
				<li>
					<span>{formatDurationClockShort(props.duration)}</span>
				</li>
				<Show when={props.viewCount != null}>
					<li>
						<span>
							{Intl.NumberFormat(undefined, {
								notation: "compact",
							}).format(props.viewCount ?? 0)}
						</span>
					</li>
				</Show>
			</MetaList>
		</VStack>
	);

	return (
		<HStack spacing="small" class="avatar-pill">
			<Show when={hasProfile()}>
				<Show
					when={props.onInfluencerClick}
					fallback={
						<Avatar
							size="small"
							alt={props.influencer?.display_name}
							src={props.influencer?.profile_picture_url}
						/>
					}
				>
					<button
						type="button"
						class="avatar-pill__profile"
						data-testid="video-evidence-influencer"
						onClick={(event) => {
							event.stopPropagation();
							props.onInfluencerClick?.(event);
						}}
					>
						<Avatar
							size="small"
							alt={props.influencer?.display_name}
							src={props.influencer?.profile_picture_url}
						/>
						{profileDetails()}
					</button>
				</Show>
			</Show>
			<Show when={!props.onInfluencerClick}>{profileDetails()}</Show>
		</HStack>
	);
};
